import { SourceTypeProject } from "@/enums/enums";
import router from "@/router";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";

const peakDomain = process.env.VUE_APP_PeakDomain;
const secretKey = process.env.VUE_APP_SecretKey;

export function MerchantId() {
  let merchantId: any = router.currentRoute.query.emi;
  merchantId = merchantId ? merchantId.PeakDecryption() : null;
  return merchantId;
}
export function GetTimezoneOffset() {
  const date = new Date().getTimezoneOffset();
  const timezoneOffset = (date * -1) / 60;
  return timezoneOffset;
}

export function IsSetCookiesInDomain() {
  let isSetDomain = false;

  if (peakDomain) {
    const domainList = location.hostname.split(".");
    const start = -(domainList.length - 1);
    const locationDomain = `.${domainList.slice(start).join(".")}`;

    if (locationDomain == peakDomain) {
      isSetDomain = true;
    }
  }

  return isSetDomain;
}
export function RefreshToken() {
  return Cookies.get("refresh_token");
}
export function AccessToken() {
  return Cookies.get("access_token");
}
export function GetKeepLogin() {
  return Cookies.get("keepLogin");
}
export function EncryptObject(obj: any) {
  const keyHex = CryptoJS.enc.Utf8.parse(secretKey);
  const jsonString = JSON.stringify(obj);
  const plaintextBytes = CryptoJS.enc.Utf8.parse(jsonString);

  const cipherText = CryptoJS.AES.encrypt(plaintextBytes, keyHex, {
    mode: CryptoJS.mode.ECB,
    keySize: 192 / 32,
  });

  const cipherTextBase64 = cipherText.toString();

  return cipherTextBase64;
}
export function DecryptSecretCodeToken(cipherText: string): any {
  const keyHex = CryptoJS.enc.Utf8.parse(secretKey);
  const plaintextBytes = CryptoJS.enc.Base64.parse(cipherText);
  try {
    const decrypted = CryptoJS.AES.decrypt(plaintextBytes.toString(CryptoJS.enc.Base64), keyHex, {
      mode: CryptoJS.mode.ECB,
      keySize: 192 / 32,
    });
    const plaintext = CryptoJS.enc.Utf8.stringify(decrypted);
    const decryptedObject = JSON.parse(plaintext);

    return decryptedObject;
  } catch (err) {
    console.log(err);
  }
}
export function SetCookiesAccessToken(accessToken: any) {
  if (accessToken) {
    if (IsSetCookiesInDomain()) {
      Cookies.set("access_token", accessToken, { domain: peakDomain });
    } else {
      Cookies.set("access_token", accessToken);
    }
  }
}
export function SetCookiesRefreshToken(refreshToken: any, keepLogin = false) {
  if (refreshToken) {
    if (IsSetCookiesInDomain()) {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30, domain: peakDomain });
      } else {
        Cookies.set("refresh_token", refreshToken, { domain: peakDomain });
      }
    } else {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30 });
      } else {
        Cookies.set("refresh_token", refreshToken);
      }
    }
  }
}
export function RemoveCookiesToken() {
  if (IsSetCookiesInDomain()) {
    Cookies.remove("access_token", { domain: peakDomain });
    Cookies.remove("refresh_token", { domain: peakDomain });
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  } else {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
  }
}

export function SetHeaderService() {
  return {
    headers: {
      source: SourceTypeProject.PeakDocument,
    },
  };
}
